module.exports = {"titleModalSuccess":"Tudo certo!","bodyModalSuccess":"Sua forma de pagamento foi alterada com sucesso!","titleModalError":"Ops! Algo deu errado","bodyModalError":"Não foi possível alterar sua forma de pagamento. Verifique os dados fornecidos e tente novamente"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditPaymentMethod/data.json
// module id = 2138
// module chunks = 0